import SendOutlinedIcon from '@mui/icons-material/SendOutlined';
import { Box, Chip, Fab, InputAdornment, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { AppTheme } from "theme";
import { requests } from 'utils/requests';

interface IProps {
  onMessage: (message: string) => void;
}

export default function MessageField(props: IProps) {
  const { t } = useTranslation();
  const [message, setMessage] = useState<string>("");
  const [presets, setPresets] = useState<string[]>([]);

  useEffect(()=>{
    requests.get("/message/preset/").then((r)=>{
      setPresets(r.body)
    })
  }, [])

  const onSubmit = () => {
    if (message.trim().length === 0) return;
    props.onMessage(message);
    setMessage("");
  }

  return (
    <Box>
      {!!presets.length && (
        <Box sx={{
          display: "flex",
          overflowX: "auto",
          mb: 1,
        }}>
          <Box sx={{
            display: "flex",
            alignItems: "center",
            flexWrap: "nowrap",
            margin: "0 auto",
            gap: 1,
          }}>
            {presets.map((value)=>(
              <Chip
                key={value}
                label={value}
                color="primary"
                size={"small"}
                onClick={()=>{
                  props.onMessage(value)
                }}
              />
            ))}
          </Box>
        </Box>
      )}
      <TextField
        placeholder={t('type_message')}
        fullWidth
        value={message}
        multiline
        maxRows={5}
        autoFocus
        onChange={(e) => {
          setMessage(e.target.value);
        }}
        onKeyDown={(e) => {
          const isMobile = window.matchMedia("(pointer: coarse)").matches;
          if (!isMobile && e.key === "Enter" && !e.shiftKey) {
            e.preventDefault();
            onSubmit();
          }
        }}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end" sx={{
              height: "auto",
              alignSelf: "flex-end",
            }}>
              <Fab
                size="small"
                color="primary"
                onClick={onSubmit}
                sx={{
                  width: 36,
                  height: 36,
                }}
              >
                <SendOutlinedIcon />
              </Fab>
            </InputAdornment>
          ),
          sx: {
            alignItems: "center",
            ":before,:after": {
              display: "none",
            },
          }
        }}
        sx={{
          borderRadius: 6,
          py: 1,
          pl: 3,
          pr: 1,
          backgroundColor: AppTheme.lightBg,
          '@media (prefers-color-scheme: dark)': {
            backgroundColor: AppTheme.lightBgDark,
          }
        }}
      />
    </Box>
  );
}